<mat-form-field appearance="outline" class="source-selector">
  <mat-label>{{ 'source.label' | translate }}</mat-label>
  <mat-select
    [value]="selectedSource"
    (selectionChange)="onSelectionChange($event)"
    aria-label="Source"
  >
    <mat-option *ngFor="let option of options" [value]="option.value">
      {{ option.labelKey | translate }}
    </mat-option>
  </mat-select>
</mat-form-field>
